export default "__VITE_ASSET__DRx8p5ft__"